let domLoaded = false;
let igReady = false;

function handleExperiments() {
  if (!domLoaded || !igReady) return;

    // Test: V_PV_PDP_18 | PDP Size & Fit Tab (Replacing Lifestyle)
    const V_PV_PDP_18 = window.igData?.user.getTestGroup("905d5098-36ab-4fec-983f-a449a5353f15");

    if (V_PV_PDP_18?.name === "Var A") {
      document.body.classList.add("c-V_PV_PDP_18-varA");
    }
}

document.addEventListener("DOMContentLoaded", () => {
  domLoaded = true;
  handleExperiments();
});

window.addEventListener("ig:ready", () => {
  igReady = true;
  handleExperiments();
}); 
